'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

import ErrorBanner from '@/components/ErrorBanner';

function ErrorPage({ error }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <ErrorBanner />;
}

export default ErrorPage;
